import { isNativeApp } from "@/lib/platform";

// Écran « Bienvenue » de l'app native (1er lancement) : acceptation CGU + Politique mémorisée sur l'appareil
// avec la version des conditions. Incrémente TERMS_VERSION lors d'une vraie modification des textes légaux :
// l'écran réapparaît une fois. Consentement distinct d'UMP/AdMob (pub) et ATT (iOS).
export const TERMS_VERSION = "2026-06";
export const WELCOME_KEY = "yalola.welcome_accepted";
// Émis sur window à l'acceptation (analytics / écrans qui attendent l'acceptation). AdMob/UMP ne s'y branche PAS :
// ils ne démarrent qu'une fois le membre connecté (App.js).
export const WELCOME_ACCEPTED_EVENT = "yalola:welcome_accepted";

export function welcomeAccepted(storage = globalThis.localStorage) {
  try {
    const d = JSON.parse(storage?.getItem(WELCOME_KEY) || "null");
    return !!d && d.v === TERMS_VERSION;
  } catch { return false; }
}

export function acceptWelcome(lang, storage = globalThis.localStorage) {
  try { storage?.setItem(WELCOME_KEY, JSON.stringify({ v: TERMS_VERSION, at: new Date().toISOString(), lang })); } catch { /* stockage indisponible */ }
  try { window.dispatchEvent(new CustomEvent(WELCOME_ACCEPTED_EVENT)); } catch { /* hors navigateur */ }
}

// QA (dev uniquement) : localStorage yalola.qa_native_welcome=1 force le parcours natif sur le web.
const qaSeam = () => {
  try { return process.env.NODE_ENV !== "production" && localStorage.getItem("yalola.qa_native_welcome") === "1"; } catch { return false; }
};

// Parcours natif (Bienvenue au 1er lancement, plus de case CGU répétée, pas de bandeau cookies).
export const nativeConsentFlow = () => isNativeApp() || qaSeam();
export const welcomeRequired = () => nativeConsentFlow() && !welcomeAccepted();
